<template>
  <div class="fin-tools-overview">
    <fin-tabs :tab-items="tabItems"
              id="fin-tools-tabs"
              :background-color-tabs="$finColors.background"
              background-color-tab-items="#FFFFFF">
      <template #actions>
        <!--v-select :items="mostUsedTools"
                  :label="mostUsedToolsLabel"
                  :color="displayColor"
                  background-color="transparent"
                  class="my-auto mr-md-12 comboBox"
                  solo
        ></v-select>

        <template v-if="$vuetify.breakpoint.mdAndUp">
          <v-btn :color="displayColor"
                 :elevation="0"
                 @click="displayAsCards=true"
                 class="mr-2 pa-0 switch-btn"
                 dark
                 tile>
            <v-icon>icon-card-view</v-icon>
          </v-btn>
          <v-btn :color="displayColor"
                 :elevation="0"
                 @click="displayAsCards=false"
                 class="switch-btn pa-0"
                 dark
                 tile>
            <v-icon>icon-list</v-icon>
          </v-btn>
        </template-->
      </template>
      <template v-for="(tab, index) in tabs"
                v-slot:[index]>
        <fin-tools-item :key="index"
                        :items="items[tab.filteredBy]"
                        style="border: none;"
        />
      </template>
    </fin-tabs>
  </div>
</template>

<script>
import toolMocks from '@/mocks/Tools'
import FinToolsItem from '@/components/pages/finTools/ToolsItem'
import FinTabs from "@/components/common/Tabs"

export default {
  name: 'fin-tools-overview',
  components: {
    FinTabs,
    FinToolsItem
  },
  data() {
    return {
      tabModel: 0,
      mostUsedTools: [
        'Aktien-Screener',
        'ETF-Analyzer',
        'Bewerte deine Aktie'
      ],
      mostUsedToolsLabel: 'Meist genutzte Tools',
      tabItems: []
    }
  },
  props: {
    tabs: {
      type: Array
    },
    mostViewed: {
      type: Boolean,
      default: true
    },
    displayColor: {
      type: String,
      default: '$finColor.primaryDark'
    }
  },
  computed: {
    items: function () {
      const items = {}
      this.tabs.forEach(tab => {
        if (tab.filteredBy === '') {
          items[tab.filteredBy] = toolMocks.items.sort((a, b) => a.orderNumber - b.orderNumber)
        } else {
          items[tab.filteredBy] =
            toolMocks.items.filter(ti => ti.filterType.includes(tab.filteredBy)).sort((a, b) => a.orderNumber - b.orderNumber)
        }
      })
      return items
    }
  },
  mounted() {
    this.tabItems = this.tabs.map((tab) => {
      return {name: tab.title}
    })
  }
}
</script>

<style lang="scss" scoped>

::v-deep {

  .v-select {
    .v-icon,
    .v-label,
    .v-select__selection {
      color: $fin-color-primary-dark;
    }

    .v-input__slot {
      box-shadow: none !important;
      margin: auto !important;
      height: 64px;
    }
  }

  .comboBox {
    box-shadow: none !important;
    height: inherit;
    width: 200px;
    font-size: 14px;
    font-weight: 600;
    line-height: 1.14;
  }
}

.switch-btn {
  margin-top: 10px;
  width: 40px !important;
  min-width: 40px !important;
  height: 40px !important;
}

.switch-btn:hover {
  text-decoration: none !important;
}

.fin-tools-overview__toolbar {
  box-shadow: $fin-color-shadow !important;
}
</style>
